(function () {
  const productScope = document.querySelector('.product-information');

  if (!productScope) return;

  function hideProductErrorMarkers() {
    const selectors = [
      '.product-details .product-form-text__error',
      '.product-details .product-form-text__error *',
      '.product-details .icon-error',
      '.product-details .svg-wrapper:has(.icon-error)',
      '.product-details [role="alert"]:empty',
      '.product-details [role="alert"]:has(.icon-error)',
    ];

    productScope.querySelectorAll(selectors.join(',')).forEach((element) => {
      element.setAttribute('hidden', '');
      element.setAttribute('aria-hidden', 'true');
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('width', '0', 'important');
      element.style.setProperty('height', '0', 'important');
      element.style.setProperty('margin', '0', 'important');
      element.style.setProperty('padding', '0', 'important');
      element.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  hideProductErrorMarkers();

  function initProductQuantityDropdowns() {
    productScope.querySelectorAll('[data-bb-product-quantity-dropdown]').forEach((dropdown) => {
      if (!(dropdown instanceof HTMLDetailsElement)) return;

      const quantitySelector = dropdown.closest('.quantity-selector-wrapper')?.querySelector('quantity-selector-component');
      const quantityInput = quantitySelector?.querySelector('input[name="quantity"]');
      const value = dropdown.querySelector('[data-bb-product-quantity-value]');
      const options = dropdown.querySelectorAll('[data-bb-product-quantity-option]');

      if (!(quantityInput instanceof HTMLInputElement)) {
        dropdown.dataset.disabled = 'true';
        return;
      }

      const updateSelection = () => {
        if (value) value.textContent = quantityInput.value;
        options.forEach((option) => {
          option.setAttribute('aria-selected', String(option.value === quantityInput.value));
        });
      };

      updateSelection();
      dropdown.dataset.disabled = String(quantityInput.disabled);

      options.forEach((option) => {
        option.addEventListener('click', () => {
          if (quantityInput.disabled) return;

          quantityInput.value = option.value;
          if (typeof quantitySelector.setQuantity === 'function') {
            quantitySelector.setQuantity({ target: quantityInput, preventDefault() {} });
          } else {
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          updateSelection();
          dropdown.open = false;
        });
      });
    });
  }

  initProductQuantityDropdowns();
})();

(function () {
  const productScope = document.querySelector('.product-information');
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  if (!productScope || !mobileMedia.matches) return;

  function initMobileGalleryThumbnails() {
    productScope.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.querySelector('.bb-mobile-gallery-thumbnails')) return;

      const slideshow = gallery.querySelector('slideshow-component');
      const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
      const dots = Array.from(
        gallery.querySelectorAll(
          ".media-gallery__mobile-controls .slideshow-controls__dots button[aria-label^='Slide']",
        ),
      );
      if (!slideshow || dots.length < 2) return;

      const thumbnailRail = document.createElement('nav');
      thumbnailRail.className = 'bb-mobile-gallery-thumbnails';
      thumbnailRail.setAttribute('aria-label', 'Product image thumbnails');

      const thumbnailButtons = dots.map((dot, index) => {
        const button = document.createElement('button');
        const sourceImage = slides[index]?.querySelector('img');

        button.type = 'button';
        button.className = 'bb-mobile-gallery-thumbnail';
        button.setAttribute('aria-label', `View product image ${index + 1}`);
        button.setAttribute('aria-current', 'false');

        if (sourceImage) {
          const image = sourceImage.cloneNode(false);
          image.alt = '';
          image.removeAttribute('id');
          image.removeAttribute('loading');
          image.setAttribute('aria-hidden', 'true');
          button.appendChild(image);
        }

        button.addEventListener('click', () => dot.click());
        thumbnailRail.appendChild(button);
        return button;
      });

      const updateSelection = () => {
        const selectedIndex = dots.findIndex((dot) => dot.getAttribute('aria-selected') === 'true');
        const activeIndex = Math.max(0, selectedIndex);

        thumbnailButtons.forEach((button, index) => {
          button.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });

        thumbnailButtons[activeIndex]?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      };

      dots.forEach((dot) => {
        new MutationObserver(updateSelection).observe(dot, {
          attributes: true,
          attributeFilter: ['aria-selected'],
        });
      });

      slideshow.insertAdjacentElement('afterend', thumbnailRail);
      updateSelection();
    });
  }

  productScope.addEventListener('variant:update', () => {
    window.requestAnimationFrame(initMobileGalleryThumbnails);
  });

  initMobileGalleryThumbnails();
})();

(function () {
  if (window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.product-information media-gallery').forEach((gallery) => {
    const nextButton = gallery.querySelector('.slideshow-control--next');
    if (!(nextButton instanceof HTMLButtonElement)) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;

      window.setTimeout(() => nextButton.classList.add('bb-gallery-next-cue'), 700);
      observer.disconnect();
    }, { threshold: 0.35 });

    observer.observe(gallery);
  });
})();
